// extracted by mini-css-extract-plugin
module.exports = {"Search":"Search_Search__BX2ZN","Search__element":"Search_Search__element__3hVBc","slide-in-left":"Search_slide-in-left__TbQ6K"};